import { baseApi } from "api/BaseApi";

import { TechCommunity, TechCommunityPayload } from "./techCommunities.types";

const TECH_COMMUNITIES_BASE_URL = "tech/communities";

const techCommunitiesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listAllTechCommunities: build.query<TechCommunity[], void>({
      query: () => `${TECH_COMMUNITIES_BASE_URL}/get_all/`,
      providesTags: ["TECH_COMMUNITIES"],
    }),

    createTechCommunity: build.mutation<TechCommunity, TechCommunityPayload>({
      query: (body) => ({
        url: `${TECH_COMMUNITIES_BASE_URL}/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["TECH_COMMUNITIES"],
    }),

    updateTechCommunity: build.mutation<
      TechCommunity,
      TechCommunityPayload & { community_id: number }
    >({
      query: ({ community_id, ...body }) => ({
        url: `${TECH_COMMUNITIES_BASE_URL}/${community_id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["TECH_COMMUNITIES"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListAllTechCommunitiesQuery,
  useCreateTechCommunityMutation,
  useUpdateTechCommunityMutation,
} = techCommunitiesApi;
